export const DEFAULT_ACCESSIBILITY_PREFS = Object.freeze({
  contrastMode: 'standard', textSize: 'normal', fontWeight: 'normal', reduceMotion: false,
  textOnly: false, audioEnabled: false, preferredVoice: null, speechRate: 1,
  onboardingCompleted: false, onboardingSkipped: false,
});

export function createPreferenceSaveQueue(send) {
  let tail = Promise.resolve();
  return { enqueue(owner, generation, payload, isCurrent) {
    const request = tail.catch(() => {}).then(() => isCurrent(owner, generation) ? send(payload) : { stale: true });
    tail = request;
    return request;
  } };
}

export function applyAccessibilityPrefs(prefs = DEFAULT_ACCESSIBILITY_PREFS) {
  const root = document.documentElement;
  root.setAttribute('data-contrast', prefs.contrastMode || 'standard');
  root.style.setProperty('--base-font-size', ({ normal: '16px', large: '18px', 'extra-large': '20px' })[prefs.textSize] || '16px');
  root.style.setProperty('--base-font-weight', prefs.fontWeight === 'bold' ? '600' : '400');
  root.setAttribute('data-font-weight', prefs.fontWeight === 'bold' ? 'bold' : 'normal');
  root.setAttribute('data-app-audio', prefs.audioEnabled ? 'on' : 'off');
  root.setAttribute('data-speech-rate', String(prefs.speechRate || 1));
  if (prefs.preferredVoice) root.setAttribute('data-speech-voice', prefs.preferredVoice); else root.removeAttribute('data-speech-voice');
  for (const [attribute, enabled] of [['data-reduce-motion', prefs.reduceMotion], ['data-text-only', prefs.textOnly]]) {
    if (enabled) root.setAttribute(attribute, 'true'); else root.removeAttribute(attribute);
  }
}

export function initAccessibility() {
  try { localStorage.removeItem('a11y_prefs'); } catch {}
  applyAccessibilityPrefs(DEFAULT_ACCESSIBILITY_PREFS);
  return DEFAULT_ACCESSIBILITY_PREFS;
}
